import { createSlice } from "@reduxjs/toolkit";
import { SORT_DIRECTION } from "../../../utils/vars";
import { useSelector } from "react-redux";

export const MONITORING_QUEUE_REDUCER_NAME = "monitoring-queue";

const initialState = {
  page: 0,
  size: 20,
  totalCount: 0,
  sort: {
    direction: SORT_DIRECTION.DESC,
    type: "DATE",
  },
  data: [],
  filters: {
    id: "",
    ruleName: "",
    personNames: "",
    contractIdentifier: "",
    assignee: "",
    status: "",
    resolution: "",
    startDate: "",
    endDate: "",
    exactDate: "",
  },
};

const monitoringQueueSlice = createSlice({
  name: MONITORING_QUEUE_REDUCER_NAME,
  initialState,
  reducers: {
    setMonitoringQueueData: (state, { payload }) => {
      state.data = [...payload];
    },
    setMonitoringQueuePage: (state, { payload }) => {
      state.page = payload;
    },
    setMonitoringQueueSize: (state, { payload }) => {
      state.size = payload;
    },
    setMonitoringQueueTotalCount: (state, { payload }) => {
      state.totalCount = payload;
    },
    setMonitoringQueueFilters: (state, { payload }) => {
      const temp = { ...state.filters };
      state.filters = { ...temp, ...payload };
    },
    setMonitoringQueueSort: (state, { payload }) => {
      state.sort = payload;
    },
    updateRow: (state, { payload }) => {
      const index = state.data.findIndex((e) => e.id === payload.id);
      if (index !== -1) {
        state.data[index] = { ...state.data[index], ...payload };
      }
    },

    clearMonitoringQueue: (state) => {
      state.page = initialState.page;
      state.size = initialState.size;
      state.totalCount = initialState.totalCount;
      state.sort = initialState.sort;
      state.data = initialState.data;
      state.filters = initialState.filters;
    },
  },
});

export const {
  clearMonitoringQueue,
  setMonitoringQueueData,
  setMonitoringQueueFilters,
  setMonitoringQueuePage,
  setMonitoringQueueSort,
  setMonitoringQueueSize,
  setMonitoringQueueTotalCount,
  updateRow,
} = monitoringQueueSlice.actions;

export default monitoringQueueSlice.reducer;

export const useSelectPageMonitoringQueue = () => {
  return useSelector((state) => state[MONITORING_QUEUE_REDUCER_NAME].page);
};

export const useSelectSizeMonitoringQueue = () => {
  return useSelector((state) => state[MONITORING_QUEUE_REDUCER_NAME].size);
};

export const useSelectDataMonitoringQueue = () => {
  return useSelector((state) => state[MONITORING_QUEUE_REDUCER_NAME].data);
};

export const useSelectTotalCountMonitoringQueue = () => {
  return useSelector(
    (state) => state[MONITORING_QUEUE_REDUCER_NAME].totalCount,
  );
};

export const useSelectFiltersMonitoringQueue = () => {
  return useSelector((state) => state[MONITORING_QUEUE_REDUCER_NAME].filters);
};

export const useSelectSortMonitoringQueue = () => {
  return useSelector((state) => state[MONITORING_QUEUE_REDUCER_NAME].sort);
};
